import React from "react";
import "./DataList.css";

export default function DataList({ title, items }) {
  return (
    <div className="data-list-container">
      <h4 className="data-list-title">{title}</h4>
      <ul className="data-list">
        {items.map((item, index) => (
          <li key={index} className="data-list-item">
            {item}
          </li>
        ))}
      </ul>
    </div>
  );
}
